import { t } from "i18next";
import PATHS from "src/routes/Paths";
import { useSidebarData } from "src/store/sidebar/SidebarData";

const SidebarItems = [
  {
    path: PATHS.dashboard,
    icon: "sidebar-dashboard-icon",
    name: t("sidebar_dashboard"),
    permissions: ["dashboard-all-children", "dashboard-my-children"],
  },
  {
    path: PATHS.children,
    icon: "sidebar-children-icon",
    name: t("sidebar_children"),
    permissions: ["children-list-in-group", "children-list-in-kindergarten"],
  },
  {
    path: PATHS.participation,
    icon: "sidebar-participation-icon",
    name: t("sidebar_participation"),
    permissions: ["children-list-participation"],
  },
  {
    path: PATHS.evaluations,
    icon: "sidebar-evaluations-icon",
    name: t("sidebar_evaluations"),
    permissions: ["children-list-evaluation-in-group"],
  },
  {
    path: PATHS.teachers,
    icon: "sidebar-teachers-icon",
    name: t("sidebar_teachers"),
    permissions: ["kindergarten-teacher-list"],
  },
  {
    icon: "sidebar-nursey-icon",
    name: t("sidebar_nursery"),
    id: "nursery",
    permissions: [
      "application-list-all",
      "transfer-list-all",
      "kindergarten-list-all",
      "application-list-to-verify",
      "transfer-list-to-verify",
    ],
    submenu: [
      {
        path: PATHS.nursery,
        name: t("sidebar_list_of_nursery"),
        permissions: ["kindergarten-list-all"],
      },
      {
        path: PATHS.registerApplicationsNursery,
        name: t("sidebar_list_of_applications_nursery"),
        permissions: ["application-list-all", "application-list-to-verify"],
      },
      {
        path: PATHS.transersListNursery,
        name: t("sidebar_transfers_nursery_list"),
        permissions: ["transfer-list-all", "transfer-list-to-verify"],
      },
    ],
  },
  {
    icon: "sidebar-kindergarten-icon",
    name: t("sidebar_kindergarten"),
    id: "kindergarten",
    permissions: [
      "application-list-all",
      "transfer-list-all",
      "transfer-list-to-verify",
      "application-list-to-verify",
    ],
    submenu: [
      {
        path: PATHS.kindergarten,
        name: t("sidebar_list_of_kindergarten", "kindergarten-list-all"),
        permissions: ["kindergarten-list-all"],
      },
      {
        path: PATHS.registerApplicationsKindergarten,
        name: t("sidebar_list_of_applications_kindergarten"),
        permissions: ["application-list-all", "application-list-to-verify"],
      },
      {
        path: PATHS.transersListKindergarten,
        name: t("sidebar_transfers_list_kindergarten_kindergarten"),
        permissions: ["transfer-list-all", "transfer-list-to-verify"],
      },
      {
        path: PATHS.transersListNurseryKindergarten,
        name: t("sidebar_transfers_list_nursery_kindergarten"),
        permissions: ["transfer-list-all", "transfer-list-to-verify"],
      },
    ],
  },
  {
    path: PATHS.kindergartenNursery,
    icon: "sidebar-kindergarten-icon",
    name: t("sidebar_kindergarten_nursery"),
    permissions: ["kindergarten-list-my-kindergartens"],
  },
  {
    icon: "sidebar-meal-icon",
    name: t("sidebar_meal"),
    id: "meal",
    permissions: [
      "food-age-group-list",
      "assortment-list",
      "food-menu-list",
      "allergy-group-list",
    ],
    submenu: [
      {
        path: PATHS.mealsAgegroups,
        name: t("sidebar_meal_age_group"),
        permissions: ["food-age-group-list"],
      },
      {
        path: PATHS.mealsAssortment,
        name: t("sidebar_meal_assortments"),
        permissions: ["assortment-list"],
      },
      {
        path: PATHS.mealsMenu,
        name: t("sidebar_meal_menu"),
        permissions: ["food-menu-list"],
      },
      {
        path: PATHS.mealsAllergy,
        name: t("sidebar_meal_allergies"),
        permissions: ["allergy-group-list"],
      },
    ],
  },
  {
    icon: "sidebar-education-program-icon",
    name: t("sidebar_education_program"),
    id: "education",
    permissions: ["education-program-monthly-list"],
    submenu: [
      {
        path: PATHS.educationList,
        name: t("sidebar_education_program_list"),
        permissions: ["education-program-monthly-list"],
      },
      {
        path: PATHS.educationAgeGroups,
        name: t("sidebar_education_program_age_group"),
        permissions: ["education-program-age-group-list"],
      },
    ],
  },
  {
    path: PATHS.groupsList,
    icon: "sidebar-groups-icon",
    name: t("sidebar_groups"),
    permissions: ["kindergartengroup-list-all", "kindergartengroup-list-my"],
  },
  {
    path: PATHS.performance,
    icon: "sidebar-performance-icon",
    name: t("sidebar_performance"),
    permissions: ["performance-list-in-kindergarten", "performance-list-my"],
  },
  {
    icon: "sidebar-children-categories-icon",
    name: t("sidebar_children_category"),
    id: "children-categories",
    permissions: ["children-category-list", "discount-list"],
    submenu: [
      {
        path: PATHS.childrensCategories,
        name: t("sidebar_children_category_list"),
        permissions: ["children-category-list"],
      },
      {
        path: PATHS.discount,
        name: t("sidebar_discount_list"),
        permissions: ["discount-list"],
      },
    ],
  },

  {
    icon: "sidebar-nursey-icon",
    name: t("sidebar_nursery"),
    id: "applications-nursery",
    permissions: ["application-list-my", "transfer-list-my"],
    submenu: [
      {
        path: PATHS.applicationsNursery,
        name: t("sidebar_list_of_applications"),
        permissions: ["application-list-my"],
      },
      {
        path: PATHS.transersNurseryList,
        name: t("sidebar_transfers_list"),
        permissions: ["transfer-list-my"],
      },
    ],
  },
  {
    icon: "sidebar-kindergarten-icon",
    name: t("sidebar_kindergarten"),
    permissions: ["application-list-my", "transfer-list-my"],
    id: "applications-kindergarten",
    submenu: [
      {
        path: PATHS.applicationsKindergarten,
        name: t("sidebar_list_of_applications"),
        permissions: ["application-list-my"],
      },
      {
        path: PATHS.transersKindergartenList,
        name: t("sidebar_transfers_list"),
        permissions: ["transfer-list-my"],
      },
      {
        path: PATHS.transfersNurseryToKindergarten,
        name: t("sidebar_transfers_nursery_kindergarten_list"),
        permissions: ["transfer-list-my"],
      },
    ],
  },
  {
    path: PATHS.staff,
    icon: "sidebar-staff-icon",
    name: t("sidebar_staff"),
    id: "staff",
    permissions: ["staff-list"],
  },
  // {
  //   path: PATHS.transersList,
  //   icon: "sidebar-transfers-icon",
  //   name: t("sidebar_transfers"),
  //   id: "transfers",
  //   permissions: [6],
  // },

  {
    path: PATHS.unregistration,
    icon: "sidebar-unregister-app-icon",
    name: t("sidebar_unregister_application"),
    permissions: [
      "children-unregister-list",
      "children-unregister-list-in-kindergarten",
      "children-unregister-list-my",
    ],
  },
  {
    path: PATHS.roles,
    icon: "sidebar-role-icon",
    name: t("sidebar-roles"),
    permissions: ["role-list"],
  },
  {
    path: PATHS.finance,
    icon: "finance-icon",
    name: t("sidebar_finance"),
    id: "finance",
    permissions: ["finance-list"],
  },
  {
    path: PATHS.reports,
    icon: "sidebar-reports-icon",
    name: t("sidebar_reports"),
    permissions: [
      "transfer-reports-list",
      "application-reports-list",
      "transfer-reports-list-in-kindergarten",
      "application-reports-list-in-kindergarten",
    ],
  },
  {
    path: PATHS.gallery,
    icon: "sidebar-transfers-icon",
    name: t("sidebar_gallery"),
    id: "gallery",
    permissions: [
      "album-list-my",
      "album-list-in-groups",
      "album-list-in-kindergarten",
    ],
  },
  // {
  //   path: PATHS.email,
  //   icon: "sidebar-email-icon",
  //   name: t("sidebar_email"),
  //   permissions: [],
  // },
  {
    path: PATHS.holidays,
    icon: "sidebar-holiday-icon",
    name: t("sidebar_holiday"),
    permissions: ["holiday-list"],
  },
  {
    path: PATHS.chat,
    icon: "sidebar-chat-icon",
    name: t("sidebar_chat"),
    id: "chat",
    permissions: ["message-thread-list"],
  },

  {
    path: PATHS.logs,
    icon: "sidebar-logs-icon",
    name: t("sidebar_logs"),
    permissions: ["activity-log-list"],
  },
  {
    path: PATHS.backup,
    icon: "sidebar-backup-icon",
    name: t("sidebar_backup"),
    permissions: ["backup-list"],
  },
];

export const useSidebarItems = () => {
  const sidebarData = useSidebarData((state: any) => state.sidebarData);
  const sidebarItems = [...SidebarItems];
  if (sidebarData.length > 0) {
    var childrenData: any = {
      icon: "sidebar-children-icon",
      name: t("sidebar_children"),
      id: "children",
      permissions: ["children-my-list"],
      submenu: sidebarData,
    };

    sidebarItems.splice(1, 0, childrenData);
  }

  return sidebarItems;
};
export default SidebarItems;
